// @ts-check
// Seção do atendimento na página do registro serviceTicket (contrato 10 de atendimento, seção 24.2): protocolo, situação,
// prazo, departamento, responsável e "Abrir na Caixa". Montada pela F0 em record-show-page.js e record-panel.js, como as
// seções da 2.0.0; some fora do atendimento, com o módulo desligado e quando o papel não lê o atendimento.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { navigate } from '../../app/router.js';
import { isTenantModuleEnabled } from '../../data/metadata-store.js';
import { getTicket } from '../../data/service-desk.js';
import { formatDateTime } from '../../lib/format.js';
import { Button } from '../../ui/button.js';
import { Skeleton } from '../../ui/feedback.js';
import { Icon } from '../../ui/icon.js';
import { ServiceChannelIcon, SlaChip, TicketValueTag } from './service-display.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ objectMetadata: import('../../lib/field-metadata.js').ObjectMetadata, record: Record<string, any>, onChanged?: () => void }} props
 */
export function ServiceTicketRecordSection({ objectMetadata, record }) {
  const isServiceTicket = objectMetadata?.nameSingular === 'serviceTicket' && isTenantModuleEnabled('SERVICE_DESK');
  const [detail, setDetail] = useState(/** @type {import('../../data/service-desk.js').TicketDetail | null} */ (null));
  const [status, setStatus] = useState(/** @type {'loading' | 'ready' | 'hidden'} */ ('loading'));
  useEffect(() => {
    if (!isServiceTicket || !record?.id) return;
    setStatus('loading');
    getTicket(record.id)
      .then((loaded) => {
        setDetail(loaded);
        setStatus(loaded?.ticket ? 'ready' : 'hidden');
      })
      .catch(() => setStatus('hidden'));
  }, [record?.id, record?.updatedAt, isServiceTicket]);
  if (!isServiceTicket || status === 'hidden') return null;
  if (status === 'loading' || !detail) return html`<section class="service-record-section"><${Skeleton} height=${64} /></section>`;
  const ticket = detail.ticket;
  return html`<section class="service-record-section" data-testid="service-ticket-record-section">
    <header class="service-record-section-header">
      <${Icon} name="IconHeadset" size=${16} />
      <span class="service-protocol">${ticket.protocol}</span>
      <${TicketValueTag} field="status" value=${ticket.status} />
      <${SlaChip} ticket=${ticket} />
      <span class="service-pane-title-spacer"></span>
      <${Button} title=${t('serviceDesk.recordSection.openInInbox')} icon="IconInbox" size="small" variant="secondary" onClick=${() => navigate(`/service/inbox/${ticket.id}`)} />
    </header>
    <dl class="service-panel-facts">
      <div><dt>${t('serviceDesk.recordSection.team')}</dt><dd>${ticket.team?.name ?? ''}</dd></div>
      <div><dt>${t('serviceDesk.recordSection.assignee')}</dt><dd>${ticket.assignee?.name ?? t('serviceDesk.pane.noAssignee')}</dd></div>
      <div><dt>${t('serviceDesk.recordSection.channel')}</dt><dd><${ServiceChannelIcon} channel=${ticket.channel} /></dd></div>
      <div><dt>${t('serviceDesk.recordSection.resolveBy')}</dt><dd>${ticket.sla?.resolutionDueAt ? formatDateTime(ticket.sla.resolutionDueAt) : t('serviceDesk.recordSection.noDue')}</dd></div>
    </dl>
  </section>`;
}
